import {
  BucketContractInputInfo,
  BucketContractInputInfoCreditCard,
  BucketContractInputInfoMobileCarrier,
} from './MemberJoinBucketDTO'

export interface BucketEditContractInputInfoConvenienceStore extends BucketContractInputInfo {
  paymentMethod: 'convenience_store',
}

export class MemberEditContractDTO {
  bucketKey: string
  contractInputInfo: BucketContractInputInfoCreditCard |
    BucketEditContractInputInfoConvenienceStore |
    BucketContractInputInfoMobileCarrier

  constructor(
    bucketKey: string,
    contractInputInfo: BucketContractInputInfoCreditCard |
      BucketEditContractInputInfoConvenienceStore |
      BucketContractInputInfoMobileCarrier,
  ) {
    this.bucketKey = bucketKey
    this.contractInputInfo = contractInputInfo
  }
}
